var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUncheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 501,
    viewBox: "0 0 500 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.048 72.5582C239.002 59.8139 260.998 59.8139 275.952 72.5582L301.389 94.2352C307.797 99.6964 315.765 102.997 324.158 103.667L357.473 106.325C377.059 107.888 392.612 123.441 394.175 143.027L396.833 176.342C397.503 184.735 400.804 192.703 406.265 199.111L427.942 224.548C440.686 239.502 440.686 261.498 427.942 276.452L406.265 301.889C400.804 308.297 397.503 316.265 396.833 324.658L394.175 357.973C392.612 377.559 377.059 393.112 357.473 394.675L324.158 397.333C315.765 398.003 307.797 401.304 301.389 406.765L275.952 428.442C260.998 441.186 239.002 441.186 224.048 428.442L198.611 406.765C192.203 401.304 184.235 398.003 175.842 397.333L142.527 394.675C122.941 393.112 107.388 377.559 105.825 357.973L103.167 324.658C102.497 316.265 99.1964 308.297 93.7352 301.889L72.0582 276.452C59.3139 261.498 59.3139 239.502 72.0582 224.548L93.7352 199.111C99.1964 192.703 102.497 184.735 103.167 176.342L105.825 143.027C107.388 123.441 122.941 107.888 142.527 106.325L175.842 103.667C184.235 102.997 192.203 99.6964 198.611 94.2352L224.048 72.5582Z",
    stroke: "white",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 320.5L248.719 250.5M248.719 250.5L180 320.5M248.719 250.5L320 180.5M248.719 250.5L180 180.5",
    stroke: "white",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheck);
export default __webpack_public_path__ + "static/media/Uncheck.2d35752bb416c3c4e564bbca8d432967.svg";
export { ForwardRef as ReactComponent };